module.exports = __webpack_public_path__ + "img/model1.4a8a8c44.png";